const PAGE_COMPONENT_TYPES = {
  TEAM_ACCM: 'team_accm',
  TEAM_GRAPHIC: 'team_graphic',
  TABLE: 'table'
};

export default {
  PAGE_COMPONENT_TYPES
};
